export default __webpack_public_path__ + "static/media/photo--sm--namrata-1.468b0510.jpg";